export const isNoiseError = (error: Error) => {
    return (
        error.message?.includes(
            'Failed to fetch dynamically imported module'
        ) ||
        error.message?.includes('Importing a module script failed') ||
        error.message?.includes('error loading dynamically imported module') ||
        error.message?.includes(
            'InvalidStateError: Failed to update a ServiceWorker for scope'
        ) ||
            error.message?.includes('InvalidStateError: newestWorker is null')
    );
};


export const noiseErrorsArray = [

    /Failed to fetch dynamically imported module/,
    /Importing a module script failed/,
    /InvalidStateError: Failed to update a ServiceWorker for scope/,
    /error loading dynamically imported module/,
    /InvalidStateError: newestWorker is null/,

]
